export const newPromotion = (kind, name = "") => kind === "plans"
  ? { name, description: "", price: "", rialPrice: "", durationDays: "", enabled: false, placementCodes: [] }
  : { code: "", title: "", description: "", enabled: true };

export function editPromotion(kind, data) {
  return kind === "plans" ? { ...data, price: data.priceMinor == null ? "" : (data.priceMinor / 100).toFixed(2),
    rialPrice: data.rialPrice == null ? "" : String(data.rialPrice), placementCodes: data.placements.map((item) => item.code) } : { ...data };
}
export function promotionPayload(kind, value) {
  const description = String(value.description ?? "").trim();
  const title = String(kind === "plans" ? value.name : value.title).trim();
  if (!title || title.length > 100 || description.length > 2000) throw new Error("عنوان یا توضیحات معتبر نیست.");
  if (kind === "placements") {
    if (!/^[a-z][a-z0-9_]{1,63}$/.test(value.code)) throw new Error("کد جایگاه باید با حرف انگلیسی کوچک شروع شود و فقط حروف کوچک، عدد و زیرخط داشته باشد.");
    const capacity = Number(value.capacity ?? 0), maximum = 100;
    if (!Number.isSafeInteger(capacity) || capacity < 0 || capacity > maximum) throw new Error("ظرفیت معتبر نیست؛ بنر VIP حداکثر یک ظرفیت دارد.");
    return { code: value.code, title, description, enabled: Boolean(value.enabled), capacity };
  }
  const priceMissing = value.price === "", durationMissing = value.durationDays === "" || value.durationDays == null;
  if (!priceMissing && !/^\d{1,7}(\.\d{1,2})?$/.test(String(value.price))) throw new Error("قیمت یورویی را حداکثر با دو رقم اعشار وارد کنید.");
  const priceMinor = priceMissing ? null : Math.round(Number(value.price) * 100), durationDays = durationMissing ? null : Number(value.durationDays);
  const rialPrice = value.rialPrice === "" || value.rialPrice == null ? null : Number(value.rialPrice);
  if (rialPrice !== null && (!/^\d{1,10}$/.test(String(value.rialPrice)) || !Number.isSafeInteger(rialPrice) || rialPrice < 1 || rialPrice > 9999999999))
    throw new Error("قیمت ریالی باید عدد صحیح مثبت باشد.");
  if ((priceMinor !== null && (priceMinor < 1 || priceMinor > 100000000))
    || (durationDays !== null && (!Number.isSafeInteger(durationDays) || durationDays < 1 || durationDays > 3650)))
    throw new Error("قیمت باید مثبت و مدت بین ۱ تا ۳۶۵۰ روز باشد.");
  if (value.placementCodes.length > 20) throw new Error("حداکثر بیست جایگاه انتخاب کنید.");
  if (value.enabled && ((priceMinor === null && rialPrice === null) || durationDays === null || !value.placementCodes.length))
    throw new Error("برای فعال‌سازی، قیمت، مدت و حداقل یک جایگاه فعال را تعیین کنید.");
  return { name: title, description, priceMinor, rialPrice, durationDays, enabled: Boolean(value.enabled), placementCodes: value.placementCodes };
}

export function promotionFilterSchema(headers) {
  return headers.filter((item) => item.hasFilter && ["enabled", "deleted"].includes(item.name)).sort((a, b) => a.filterOrder - b.filterOrder)
    .map((item) => ({ name: item.name, title: item.title, type: "enum",
      ...(item.name === "deleted" ? { emptyTitle: "پلن‌های جاری", options: [{ value: "true", title: "حذف‌شده‌ها" }] }
        : { options: [{ value: "true", title: "فعال" }, { value: "false", title: "غیرفعال" }] }) }));
}
